import { Injectable } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import { MessagePlaceholders, DialogResult, DialogService } from 'dspx-core';

@Injectable({
  providedIn: 'root'
})
export class AsyncDialogService {

  constructor(
    private dialogService: DialogService) {
  }

  async showConfirmPopup(popupCode: string, data?: MessagePlaceholders): Promise<DialogResult> {
    const dialogResult = await firstValueFrom(this.dialogService.showConfirmPopup(popupCode, data));
    return dialogResult;
  }
}
